import { render, staticRenderFns } from "./Advanced-Button-Wrapper.vue?vue&type=template&id=79d6537b&"
import script from "./Advanced-Button-Wrapper.vue?vue&type=script&lang=js&"
export * from "./Advanced-Button-Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports